export type LawyerSignupFlow = "organic" | "cold-email" | "invited";

const SIGNUP_SOURCE_KEY = "lawyer_signup_source";

const SIGNUP_SOURCE_BY_FLOW: Record<LawyerSignupFlow, string> = {
  organic: "inbound",
  "cold-email": "founder_outreach",
  invited: "family_estate",
};

export function saveLawyerSignupSource(flow: LawyerSignupFlow): void {
  sessionStorage.setItem(SIGNUP_SOURCE_KEY, SIGNUP_SOURCE_BY_FLOW[flow]);
}

export function readLawyerSignupSource(): string | undefined {
  return sessionStorage.getItem(SIGNUP_SOURCE_KEY) ?? undefined;
}

export function clearLawyerSignupSource(): void {
  sessionStorage.removeItem(SIGNUP_SOURCE_KEY);
}
